
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ClassificationDetail } from '../../../models/classification.model';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
  selector: 'app-classification-details-form',
  template: `
    <form [formGroup]="addEditFormDetails" (ngSubmit)="saveOrUpdate()" RestrictFocus>
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row bottom-10-margin">
          <div class="ui-grid-col-4"><label>{{ 'common.classification_code' | translate}}</label></div>
          <div class="ui-grid-col-8"><input formControlName="code" pInputText/></div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
          <div class="ui-grid-col-4"><label>{{ 'common.classification_description' | translate}}</label></div>
          <div class="ui-grid-col-8"><input formControlName="description" pInputText/></div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                  [disabled]="!addEditFormDetails.valid || !addEditFormDetails.dirty"
                  [label]="'common.add_classification' | translate"></button>
        </div>
      </p-footer>
    </form>
  `
})
export class ClassificationDetailsForm2Component implements OnChanges {


  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: ClassificationDetail;

  addEditFormDetails: FormGroup;


  constructor(private fb: FormBuilder,
              private svcClassification: ClassificationService) {


  }


  ngOnChanges(changes: SimpleChanges): void {
    this.addEditFormDetails = this.fb.group({
      'code': new FormControl(this.editingElement.code, Validators.compose([Validators.required, Validators.maxLength(100)])),
      'description': new FormControl(this.editingElement.description, Validators.compose([Validators.required, Validators.maxLength(100)]))
    });
  }

  saveOrUpdate(): void {

    let newData = Object.assign({}, this.editingElement, this.addEditFormDetails.value);
    this.onAddElement.emit(newData);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-details-form.component.ts